'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import MediaListingItem from './mediaListingItem';
import LoadingSpinner from 'components/spinner/spinner';
import MediaListingEmpty from './mediaListingEmpty';

var MediaListingPage = React.createClass({
    displayName: 'MediaListingPage',
    mixins: [],
    propTypes: {},
    render() {
        if (flux.getStore('media').isLoading() || flux.getStore('basket').isLoading() || flux.getStore('modals').getState().loading) {
            return (<LoadingSpinner/>);
        }

        if (this.props.mediaStore.media.size === 0) {
            return <MediaListingEmpty />;
        }

        const { defaultResultView } = flux.getStore('app').getState().config.toJS();
        const layout = store.get('active_layout') || defaultResultView || 'large_preview';
        const amountEmbargo = this.props.mediaStore.media.toJS().filter(x => x.embargo).length;
        const amountArchive = this.props.mediaStore.media.toJS().filter(x => x.archived).length;
        const amountMarked = amountEmbargo + amountArchive;

        return (
            <div className={`media__listing layout__${layout} ${amountMarked > 0 ? 'media__listing__marked' : ''}`}>
                {this.props.mediaStore.media.map((item) => {
                    return <MediaListingItem key={'mlitem-' + item.get('id')} item={item} layout={layout} slotDefinitions={this.props.mediaStore.slotDefinitions} />;
                })}
            </div>
        );
    }
});

module.exports = MediaListingPage;



// WEBPACK FOOTER //
// ./app/pages/media/mediaListing.jsx